import AodObject from './AodObject';

export default function SpecAd(record, aodService)
{
    AodObject.call(this, record, aodService, 'SpecAd');
}

SpecAd.prototype = Object.create(
    AodObject.prototype,
    {
        lock: {
            value: function lock()
            {
                const self = this;
                return this.itemCall.lock(this.id)
                    .then(function(response)
                    {
                        //return new self.constructor(response[self.item]);
                        return self.aodService.factory.get(self.objType, response[self.callName]);
                    });
            }
        },
        unLock: {
            value: function lock()
            {
                const self = this;
                return this.itemCall.unlock(this.id)
                    .then(function(response)
                    {
                        //return new self.constructor(response[self.item]);
                        return self.aodService.factory.get(self.objType, response[self.callName]);
                    });
            }
        },
    }
);

SpecAd.prototype.constructor = SpecAd;